import { Skeleton } from "../skeleton/index";
import "./pagination.css";

export const PaginationLoader = () => {
  return (
    <div className="pagination">
      <Skeleton style={{ height: "12px", borderRadius: "10px", width: "175px" }} />
      <div className="paging-block">
        <Skeleton
          style={{ height: "12px", borderRadius: "10px", width: "50px", marginRight: "10px" }}
        />
        <Skeleton
          style={{ height: "32px", borderRadius: "4px", width: "32px", marginRight: "4px" }}
        />
        <Skeleton
          style={{ height: "32px", borderRadius: "4px", width: "32px", marginRight: "4px" }}
        />
        <Skeleton
          style={{ height: "32px", borderRadius: "4px", width: "32px", marginRight: "4px" }}
        />
        <Skeleton
          style={{ height: "32px", borderRadius: "4px", width: "32px", marginRight: "4px" }}
        />
        <Skeleton
          style={{ height: "32px", borderRadius: "4px", width: "32px", marginRight: "4px" }}
        />
        <Skeleton
          style={{ height: "32px", borderRadius: "4px", width: "32px", marginRight: "4px" }}
        />
        <Skeleton
          style={{ height: "32px", borderRadius: "4px", width: "32px", marginRight: "4px" }}
        />
      </div>
    </div>
  );
};
